import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import { OnboardingStepperHeaderIcon } from "@src/components/MainApp/Onboarding/components/OnboardingStepperHeaderIcon";

interface OnboardingHeaderStepperProps {
  currentStep: number;
}

const steps = ["About You", "Your Store", "Goals", "Additional Info"];
export const OnboardingHeaderStepper = ({
  currentStep,
}: OnboardingHeaderStepperProps) => {
  return (
    <Grid container rowSpacing={8} direction={"column"} item xs={12}>
      <Grid item>
        <LinearProgress
          variant={"determinate"}
          value={(currentStep + 1) * 25}
        />
      </Grid>
      <Grid item container direction={"row"} justifyContent={"space-between"}>
        {steps.map((label, index) => (
          <Grid direction={"column"} key={index} item alignItems={"center"}>
            <Grid
              xs={3}
              alignItems={"center"}
              item
              container
              direction={"column"}
              key={index}
            >
              <Grid item>
                <OnboardingStepperHeaderIcon
                  sx={{ fontSize: "32px" }}
                  active={currentStep === index}
                  completed={currentStep > index}
                />
              </Grid>
              <Grid item>
                <IgTypography>{label}</IgTypography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
